import { CheckOutlined, CloseOutlined, CommentOutlined, DeleteOutlined, SaveOutlined, SendOutlined, UndoOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Form, InputNumber, Row, Space, Tabs } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import dayjs, { Dayjs } from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { chatLuongKPI, diemXepLoaiKPI, idNhomKPI, maChucVu, tienDoKPI, trangThaiKPI } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { convertToRoman, validateMessages } from '../../helpers/common';
import { ChiTietKPICaNhan, KPIDuyetResponse, NhomKPICaNhan } from '../../models/kpi/KPICaNhan';
import { LogNguoiDung } from '../../models/lognguoidung/LogNguoiDung';
import { HanChotKPIResponse } from '../../models/setting/Setting';
import { lanhDaoPhongPheDuyetKPI, layKPICaNhan, layNhomKPICaNhan, layCongViecChuaHoanThanh, layThongTinNhanVien, luuKPICaNhan, luuTaiLieuKPICaNhan, pheDuyetKPICaNhan, thuHoiKPICaNhan, xoaKPICaNhan, duaYKienKPICaNhan, layDSTieuDeKPITheoNhanVien } from '../../services/kpi';
import { layHanChotTrinhKPI } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import DiemPheDuyetSelectBox from '../utils/DiemPheDuyetSelectBox';
import LogNguoiDungTable from '../utils/LogNguoiDungTable';
import EditChiTietKPITab from './EditChiTietKPITab';
import HuongDanDanhGiaKPI from './HuongDanDanhGiaKPI';
import ThongKeLoiViPham from './ThongKeLoiViPhamCaNhan';
import TrangThaiTag from './TrangThaiTag';
import ViewChiTietKPITab from './ViewChiTietKPITab';
import { getDiemDanhGiaByDiemXepLoai, getDiemXepLoaiByDiemDanhGia } from './kpiHelper';
import ThongKeKPICaNhan from './ThongKeKPICaNhan';

const ChiTietKPI = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.KPI.ChiTietKPI,
        Links.KPI.ThemKPI,
        Links.KPI.LanhDaoPhongDuyet,
        Links.KPI.LanhDaoPhuTrachDuyet,
        Links.KPI.LanhDaoDonViDuyet
    ]);
    const [form] = useForm();
    const [idKPI, setIdKPI] = useState<number>(() => {
        const params = new URLSearchParams(window.location.search);
        return +(params.get('id') || '') || 0;
    });
    const [idNhanVien, setIdNhanVien] = useState<number>(user.idNhanVien);
    const [idBanDieuHanh, setIdBanDieuHanh] = useState<number>(0);
    const [idChucVu, setIdChucVu] = useState<number>(0);
    const [tenNhanVien, setTenNhanVien] = useState<string>("");
    const [thangNam, setThangNam] = useState<string>("");
    const [ngayThang, setNgayThang] = useState<Dayjs>(dayjs());
    const [idDonVi, setIdDonVi] = useState<number>(user.idDonVi);
    const [idLanhDaoPhuTrach, setIdLanhDaoPhuTrach] = useState<number>(0);
    const [diemChuyenMon, setDiemChuyenMon] = useState<number>(0);
    const [tenDonVi, setTenDonVi] = useState<string>(user.tenDonVi);
    const [trangThai, setTrangThai] = useState<number>(-1);
    const [xepLoai, setXepLoai] = useState<string>("Chưa xếp loại");
    const [isDisable, setIsDisable] = useState(false);
    const [isShowError, setIsShowError] = useState(false);
    const [isReloadPage, setIsReloadPage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showDetail, setShowDetail] = useState(true);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    type FieldKPICaNhan = {
        "thangNam": Date;
    };

    const [nhomKPI, setNhomKPI] = useState<Array<NhomKPICaNhan>>([]);
    const [logs, setLogs] = useState<Array<LogNguoiDung>>([]);
    const [diemPheDuyet, setDiemPheDuyet] = useState<number>(0);
    const [diemDanhGia, setDiemDanhGia] = useState<number>(0);
    const [diemDanhGiaLabel, setDiemDanhGiaLabel] = useState<number | null>(null);

    const [openModalPheDuyet, setOpenModalPheDuyet] = useState(false);
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuaYKien, setOpenModalDuaYKien] = useState(false);
    const [openModalTrinh, setOpenModalTrinh] = useState(false);
    const [openModalTraLai, setOpenModalTraLai] = useState(false);
    const [openModalLDPhongPheDuyet, setOpenModalLDPhongPheDuyet] = useState(false);

    const [isLDPhong, setIsLDPhong] = useState(false);
    const [hasLDPhuTrach, setHasLDPhuTrach] = useState(false);
    const [hasQuyenYKien, setHasQuyenYKien] = useState(false);
    const [yKien, setYKien] = useState<string>("");

    const [lyDo, setLyDo] = useState<string>("");
    const [isTrinh, setIsTrinh] = useState(false);

    // Lấy hạn chót trình KPI theo cấu hình (đã lùi qua ngày nghỉ / ngày lễ) tương ứng với vai trò người dùng
    const getHanChot = async (date: Dayjs): Promise<Dayjs | null> => {
        if (user.maChucVu === maChucVu.giamDoc) {
            return null;
        }
        try {
            const hanChot: HanChotKPIResponse | null = await layHanChotTrinhKPI(date.format(monthFormat));
            if (!hanChot) {
                return null;
            }
            let ngay = hanChot.ngayNhanVien;
            if (idBanDieuHanh > 0) {
                ngay = hanChot.ngayBanDieuHanh;
            } else if (user.isLanhDaoPhong || isLDPhong) {
                ngay = hanChot.ngayLanhDaoPhong;
            }
            return ngay ? ngay.endOf('day') : null;
        } catch {
            return null;
        }
    }

    const eventLoadNhomKPI = async () => {
        var defaultKPINoiQuy: Array<ChiTietKPICaNhan> = ([
            {
                key: 0,
                id: 0,
                thuTuStr: "1",
                idKPI: 0,
                idNhomKPI: idNhomKPI.noiQuy,
                tenCongViec: "Chấp hành quy định của pháp luật, chính sách của Đảng, Nhà nước",
                thoiGianGiao: ngayThang.startOf('month').toDate(),
                thoiGianYeuCauHoanThanh: ngayThang.endOf('month').toDate(),
                chatLuong: chatLuongKPI.tot,
                tienDo: tienDoKPI.dung,
                ghiChu: "",
                diemCaNhan: null,
                diemLanhDaoPhong: null,
                diemLanhDaoPhuTrach: null,
                isTieuDe: 0,
                thuTu: 1
            },
            {
                key: 1,
                id: 0,
                thuTuStr: "2",
                idKPI: 0,
                idNhomKPI: idNhomKPI.noiQuy,
                tenCongViec: "Chấp hành nghiêm túc nội quy, quy chế cơ quan",
                thoiGianGiao: ngayThang.startOf('month').toDate(),
                thoiGianYeuCauHoanThanh: ngayThang.endOf('month').toDate(),
                chatLuong: chatLuongKPI.tot,
                tienDo: tienDoKPI.dung,
                ghiChu: "",
                diemCaNhan: null,
                diemLanhDaoPhong: null,
                diemLanhDaoPhuTrach: null,
                isTieuDe: 0,
                thuTu: 2
            },
            {
                key: 2,
                id: 0,
                idKPI: 0,
                thuTuStr: "3",
                idNhomKPI: idNhomKPI.noiQuy,
                tenCongViec: "Phối hợp tốt với đồng  nghiệp trong công tác chuyên môn; tác phong, thái độ lịch sự, đúng mực khi làm việc giao dịch với khách hàng, đơn vị ngoài cơ quan",
                thoiGianGiao: ngayThang.startOf('month').toDate(),
                thoiGianYeuCauHoanThanh: ngayThang.endOf('month').toDate(),
                chatLuong: chatLuongKPI.tot,
                tienDo: tienDoKPI.dung,
                ghiChu: "",
                diemCaNhan: null,
                diemLanhDaoPhong: null,
                diemLanhDaoPhuTrach: null,
                isTieuDe: 0,
                thuTu: 3
            },
            {
                key: 3,
                id: 0,
                idKPI: 0,
                thuTuStr: "4",
                idNhomKPI: idNhomKPI.noiQuy,
                tenCongViec: "Tham gia đầy đủ, tích cực các hoạt động do cơ quan, đoàn thể phát động",
                thoiGianGiao: ngayThang.startOf('month').toDate(),
                thoiGianYeuCauHoanThanh: ngayThang.endOf('month').toDate(),
                chatLuong: chatLuongKPI.tot,
                tienDo: tienDoKPI.dung,
                ghiChu: "",
                diemCaNhan: null,
                diemLanhDaoPhong: null,
                diemLanhDaoPhuTrach: null,
                isTieuDe: 0,
                thuTu: 4
            }
        ]);
        const hanChot = await getHanChot(ngayThang);
        const isTre = hanChot ? dayjs().isAfter(hanChot) : false;
        defaultKPINoiQuy.push({
            key: 4,
            id: 0,
            idKPI: 0,
            thuTuStr: "5",
            idNhomKPI: idNhomKPI.noiQuy,
            tenCongViec: "Thực hiện báo cáo công việc hàng tháng",
            thoiGianGiao: ngayThang.startOf('month').toDate(),
            thoiGianYeuCauHoanThanh: ngayThang.endOf('month').toDate(),
            chatLuong: chatLuongKPI.tot,
            tienDo: isTre ? tienDoKPI.tre : tienDoKPI.dung,
            ghiChu: "",
            diemCaNhan: isTre ? -4 : null,
            diemLanhDaoPhong: null,
            diemLanhDaoPhuTrach: null,
            isTieuDe: 0,
            thuTu: 4,
            macDinh: true // mặc định của hệ thống, cá nhân k đc can thiệp
        });
        var defaultNhomKPI = await layNhomKPICaNhan();
        if (defaultNhomKPI) {
            const newNhomKPI = (defaultNhomKPI as Array<NhomKPICaNhan>);
            for (const x of newNhomKPI) {
                x.tuDanhGia = x.diemChuan;
                x.lanhDaoPhong = x.diemChuan;
                x.lanhDaoPhuTrach = x.diemChuan;

                if (x.tuDanhGia > 0) {
                    if (x.chiTiet != null && x.chiTiet.length > 0) {
                        x.isValid = true;
                    } else x.isValid = false;
                } else x.isValid = true;

                if (x.id == idNhomKPI.noiQuy) {
                    x.chiTiet = defaultKPINoiQuy;
                    x.isValid = true;
                    x.tuDanhGia = isTre ? x.diemChuan - 4 : x.diemChuan;
                }
                if (x.id == idNhomKPI.chuyenMon) {
                    const thangNamParam = ngayThang.format(monthFormat);
                    let chiTietCongViec: Array<ChiTietKPICaNhan> = [];
                    var dsTieuDe = await layDSTieuDeKPITheoNhanVien();
                    if (dsTieuDe && (dsTieuDe as Array<any>).length > 0) {
                        chiTietCongViec.push(...(dsTieuDe as Array<any>).map((cv: any, idx: number) => ({
                            key: chiTietCongViec.length + idx,
                            id: 0,
                            idCha: 0,
                            idChaKpi: 0,
                            idKPI: 0,
                            idNhomKPI: idNhomKPI.chuyenMon,
                            tenCongViec: cv.noiDung,
                            chatLuong: null,
                            tienDo: null,
                            ghiChu: "",
                            diemCaNhan: null,
                            diemLanhDaoPhong: null,
                            diemLanhDaoPhuTrach: null,
                            isTieuDe: 1,
                            thuTu: chiTietCongViec.length + idx + 1,
                            thuTuStr: String(chiTietCongViec.length + idx + 1)
                        })));
                    }
                    var dsCongViec = await layCongViecChuaHoanThanh(thangNamParam);
                    if (dsCongViec && (dsCongViec as Array<any>).length > 0) {
                        chiTietCongViec.push(...(dsCongViec as Array<any>).map((cv: any, idx: number) => ({
                            key: chiTietCongViec.length + idx,
                            id:  0,
                            idCha: cv.id,
                            idChaKpi: cv.idKPI,
                            idNVGiao: cv.idNVGiao,
                            idKPI: 0,
                            idNhomKPI: idNhomKPI.chuyenMon,
                            tenCongViec: cv.tenCongViec,
                            thoiGianGiao: cv.thoiGianGiao,
                            thoiGianYeuCauHoanThanh:  ngayThang.endOf('month').toDate(),
                            chatLuong: cv.chatLuong ?? null,
                            tienDo: cv.tienDo ?? null,
                            ghiChu: cv.ghiChu ?? "",
                            diemCaNhan: cv.tienDo == tienDoKPI.tre ? -4 : null,
                            diemLanhDaoPhong: null,
                            diemLanhDaoPhuTrach: null,
                            isTieuDe: cv.isTieuDe ?? 0,
                            thuTu: chiTietCongViec.length + idx + 1,
                            thuTuStr: String(chiTietCongViec.length + idx + 1)
                        })));
                    }
                    // Đánh lại số thứ tự: tiêu đề đánh số La Mã, công việc đánh số đếm lại từ đầu mỗi tiêu đề
                    let stt = 0;
                    let roman = 0;
                    chiTietCongViec.forEach((item) => {
                        if (item.isTieuDe === 1) {
                            item.thuTuStr = convertToRoman(++roman);
                            stt = 0;
                        } else {
                            item.thuTuStr = String(++stt);
                        }
                    });
                    x.chiTiet = chiTietCongViec;
                    x.isValid = true;
                    // Tính lại tuDanhGia: diemChuan trừ tổng điểm âm từ các công việc chưa hoàn thành
                    const tongDiemTru = chiTietCongViec.reduce((sum: number, item: ChiTietKPICaNhan) => {
                        return sum + (item.diemCaNhan != null && item.diemCaNhan < 0 ? item.diemCaNhan : 0);
                    }, 0);
                    x.tuDanhGia = x.diemChuan + tongDiemTru;
                }
            }

            setNhomKPI((defaultNhomKPI as Array<NhomKPICaNhan>));
        }
        else {
            setNhomKPI([]);
        }
    }

    const eventLoadKPI = async (id: number) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            if (id > 0) {
                var data = await layKPICaNhan(id);
                setThangNam(dayjs(data.thangNam).format(monthFormat));
                form.setFieldsValue({
                    thangNam: dayjs(data.thangNam)
                });

                setNgayThang(dayjs(data.thangNam));
                setIdNhanVien(data.idNhanVien);
                setIdBanDieuHanh(data.idBanDieuHanh);
                setTenNhanVien(data.tenNhanVien);
                setTenDonVi(data.tenDonVi);
                setIdDonVi(data.idDonVi);
                setIdChucVu(data.idChucVu);

                data.nhomKPI.map((x: NhomKPICaNhan) => {
                    if (x.tuDanhGia > 0) {
                        if (x.chiTiet != null && x.chiTiet.length > 0) {
                            x.isValid = true;
                        } else x.isValid = false;
                    } else x.isValid = true;
                });
                setIsLDPhong(data.isLanhDaoPhong);
                if (data.idLanhDaoPhuTrach > 0) {
                    setHasLDPhuTrach(true);
                    setIdLanhDaoPhuTrach(data.idLanhDaoPhuTrach);
                    setHasQuyenYKien(data.quyenYKien);
                    setYKien(data.yKien);
                    setLyDo(data.yKien);
                }
                const chuyenMon = data.nhomKPI.find(x => x.id == 1);
                setDiemChuyenMon(chuyenMon.lanhDaoPhuTrach > 0 ? chuyenMon.lanhDaoPhuTrach : chuyenMon.lanhDaoPhong > 0 ? chuyenMon.lanhDaoPhong : chuyenMon.tuDanhGia);
                setTrangThai(data.trangThai);

                switch (data.trangThai) {
                    case trangThaiKPI.trinhLanhDaoPhong:
                        if (data.nhomKPI) {
                            data.nhomKPI.map((x: NhomKPICaNhan, idx: number) => {
                                if (x.lanhDaoPhong <= 0 && menu[Links.KPI.LanhDaoPhongDuyet] && data.idNhanVien != user.idNhanVien) {
                                    x.lanhDaoPhong = x.tuDanhGia;
                                    x.chiTiet.forEach((item) => {
                                        item.diemLanhDaoPhong = item.diemCaNhan;
                                    })
                                }
                            })
                        }
                        break;
                    case trangThaiKPI.trinhLanhDaoPhuTrach:
                        if (data.nhomKPI) {
                            data.nhomKPI.map((x: NhomKPICaNhan, idx: number) => {
                                if (menu[Links.KPI.LanhDaoPhuTrachDuyet]) {
                                    if (data.id > 0) {
                                        if (!data.isLanhDaoPhong) {
                                            if (x.lanhDaoPhuTrach <= 0) {
                                                x.lanhDaoPhuTrach = x.lanhDaoPhong;
                                                x.chiTiet.forEach((item) => {
                                                    item.diemLanhDaoPhuTrach = item.diemLanhDaoPhong;
                                                })
                                            }
                                        } else {
                                            if (x.lanhDaoPhuTrach <= 0) {
                                                x.lanhDaoPhuTrach = x.tuDanhGia;
                                                x.chiTiet.forEach((item) => {
                                                    item.diemLanhDaoPhuTrach = item.diemCaNhan;
                                                })
                                            }
                                        }
                                    } else {
                                        if (x.lanhDaoPhuTrach <= 0) {
                                            x.lanhDaoPhuTrach = x.tuDanhGia;
                                            x.chiTiet.forEach((item) => {
                                                if (item.diemLanhDaoPhuTrach === null) {
                                                    item.diemLanhDaoPhuTrach = item.diemCaNhan;
                                                }
                                            })
                                        }
                                    }
                                };
                            })
                        }
                        break;
                }

                eventSetXepLoai(data.diemXepLoai);
                setDiemDanhGiaLabel(data.diemDanhGia);
                setNhomKPI(data.nhomKPI);
                setLogs(data.logs);
            } else {
                var data = await layThongTinNhanVien();
                setThangNam(dayjs(new Date()).format(monthFormat));
                form.setFieldsValue({
                    thangNam: dayjs(new Date())
                });
                setIsLDPhong(data.isLanhDaoPhong);
                setIdNhanVien(data.idNhanVien);
                setTenNhanVien(data.hoTen);
                setIdBanDieuHanh(data.idBanDieuHanh);
                setTenDonVi(data.tenDonVi);
                setIdDonVi(data.idDonVi);
                setIdChucVu(data.idChucVu);
                setIdLanhDaoPhuTrach(0);
                setTrangThai(-1);
                await eventLoadNhomKPI();
                eventSetXepLoai(0);
            }
        } catch (e) {
            toast.error("Không thể lấy thông tin KPI");
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const checkTenCongViec = () => {
        if (nhomKPI != null && nhomKPI.length > 0) {
            var check = nhomKPI.find((nhom) => {
                if (nhom.chiTiet != null && nhom.chiTiet.length > 0) {
                    return nhom.chiTiet.find((ct) => ct.tenCongViec == null || ct.tenCongViec == "");
                } else return null;
            });
            if (check != null && check != undefined) {
                toast.error("Vui lòng nhập đầy đủ tên công việc");
                return false;
            } else return true;
        } return true;
    }

    const checkChiTietKPI = () => {
        var check = true;
        var names: string[] = [];
        nhomKPI.map((x: NhomKPICaNhan, idx: number) => {
            if (x.tuDanhGia > 0) {
                if (x.chiTiet == null || x.chiTiet.length <= 0) {
                    x.isValid = false;
                    check = false;
                    names.push(x.ten);
                }
            }
        })
        if (!check) {
            var name = names.join(", ");
            toast.error("Vui lòng thêm công việc cho các KPI: " + name);
        }
        return check;
    }

    const onFinish = (values: any) => {
        if (checkChiTietKPI() && checkTenCongViec()) {
            setIsShowError(false);
            if (isTrinh) {
                setLyDo("");
                setOpenModalTrinh(true);
            } else {
                nhomKPI.forEach((item: NhomKPICaNhan) => {
                    (item.chiTiet || []).forEach((chiTiet: ChiTietKPICaNhan, index: number) => {
                        chiTiet.thuTu = index + 1;
                    });
                });

                setConfirmModal({
                    isShowModal: true,
                    title: "Lưu KPI",
                    content:
                        <>Bạn có muốn <label>Lưu</label> KPI này không?</>,
                    onSubmit: eventSaveKPI
                });
            }
        } else setIsShowError(true);
    };

    const eventSaveKPI = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values: {
            thangNam: { $d: any; };
        }) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);

            try {
                var request = {
                    id: idKPI,
                    idNhanVien: idNhanVien,
                    idDonVi: idDonVi,
                    tenDonVi: tenDonVi,
                    idChucVu: idChucVu,
                    idBanDieuHanh: idBanDieuHanh,
                    thangNam: values.thangNam.$d,
                    nhomKPI: nhomKPI
                };

                const id = await luuKPICaNhan(request);
                const hasTaiLieu = nhomKPI.some(item =>
                    (item.idsTaiLieuXoa?.length ?? 0) > 0 ||
                    (item.dsTaiLieu?.length ?? 0) > 0
                );
                if (hasTaiLieu) {
                    await luuTaiLieuKPICaNhan({
                        id,
                        nhomKPI
                    });
                }
                toast.success("Lưu KPI thành công");
                setIdKPI(id);
                navigate(Links.KPI.ChiTietKPI + "?id=" + id);
            } catch (error: any) {
                toast.error(error);
            }

            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
        });
    }

    const eventTrinhKPI = async (isPheDuyet: boolean) => {
        if (isLoading) return;
        setIsLoading(true);
        form.validateFields().then(async (values: {
            thangNam: { $d: any; };
        }) => {
            dispatch(showLoadingScreen())

            // set số thứ tự
            nhomKPI.forEach((item: NhomKPICaNhan) => {
                (item.chiTiet || []).forEach((chiTiet: ChiTietKPICaNhan, index: number) => {
                    chiTiet.thuTu = index + 1;
                });
            });

            try {
                var request = {
                    id: idKPI,
                    idNhanVien: idNhanVien,
                    thangNam: values.thangNam.$d,
                    isDuyet: isPheDuyet,
                    idDonVi: idDonVi,
                    tenDonVi: tenDonVi,
                    idChucVu: idChucVu,
                    idBanDieuHanh: idBanDieuHanh,
                    lyDo: lyDo,
                    nhomKPI: nhomKPI
                };

                const id = await luuKPICaNhan(request);

                const hasTaiLieu = nhomKPI.some(item =>
                    (item.idsTaiLieuXoa?.length ?? 0) > 0 ||
                    (item.dsTaiLieu?.length ?? 0) > 0
                );
                if (hasTaiLieu) {
                    await luuTaiLieuKPICaNhan({
                        id,
                        nhomKPI
                    });
                }
                if (idKPI <= 0) {
                    setIdKPI(id);
                    toast.success(isPheDuyet ? "Lưu & trình KPI thành công" : "Trả lại KPI thành công");
                    navigate(Links.KPI.ChiTietKPI + "?id=" + id);
                }
                else {
                    if ((menu[Links.KPI.LanhDaoPhongDuyet] || menu[Links.KPI.LanhDaoPhuTrachDuyet] || menu[Links.KPI.LanhDaoDonViDuyet]) && idBanDieuHanh <= 0) {
                        if (id > 0) {
                            toast.success(isPheDuyet ? "Phê duyệt KPI thành công! Chuyển qua phê duyệt KPI của nhân viên khác" : "Trả lại KPI thành công! Chuyển qua phê duyệt KPI của nhân viên khác");
                            setIdKPI(id);
                            navigate(Links.KPI.ChiTietKPI + "?id=" + id);
                        } else {
                            toast.success(isPheDuyet ? "Phê duyệt KPI thành công! Đã hết KPI cần duyệt" : "Trả lại KPI thành công! Đã hết KPI cần duyệt");
                            navigate(Links.KPI.DuyetKPI + "?thangNam=" + thangNam);
                        }
                    } else {
                        toast.success(isPheDuyet ? "Lưu & trình KPI thành công" : "Trả lại KPI thành công");
                        setIsReloadPage(true);
                    }
                }
            } catch (error: any) {
                toast.error(error);
            }

            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            setIsLoading(false);
            toast.error(e);
        });
        setIsLoading(false);
    }

    const eventDeleteKPI = async () => {
        if (isLoading) return;

        dispatch(showLoadingScreen())
        setIsLoading(true);

        try {
            await xoaKPICaNhan(idKPI);
            navigate(Links.KPI.KPICaNhan);
            toast.success("Xóa KPI thành công");
        }
        catch (e: any) {
            toast.error("Xóa KPI không thành công");
        };

        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const eventDuaYKien = async () => {
        if (!lyDo) {
            toast.error("Vui lòng nhập ý kiến");
            return;
        }
        if (isLoading) return;
        dispatch(showLoadingScreen())
        setIsLoading(true);
        try {
            var request = {
                lyDo: lyDo,
                id: idKPI
            };
            var id = await duaYKienKPICaNhan(request);
            if (id > 0) {
                toast.success("Đưa ý kiến KPI thành công! Chuyển qua đưa ý kiến KPI của nhân viên khác");
                setIdKPI(id);
                navigate(Links.KPI.ChiTietKPI + "?id=" + id);
            } else {
                toast.success("Đưa ý kiến KPI thành công! Đã hết KPI cần đưa ý kiến");
                navigate(Links.KPI.YKienKPI + "?thangNam=" + thangNam);
            }
        } catch (e: any) {
            toast.error("Đưa ý kiến KPI không thành công");
        }

        setOpenModalDuaYKien(false);
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }
    const eventPheDuyetKPI = async (isPheDuyet: boolean) => {
        if (isLoading) return;
        dispatch(showLoadingScreen())
        setIsLoading(true);

        try {
            var info: Array<KPIDuyetResponse> = [{
                idKPICaNhan: idKPI,
                thangNam: ngayThang,
                hoTen: "",
                tenChucVu: "",
                tuDanhGia: 0,
                lanhDaoPhong: 0,
                lanhDaoPhuTrach: 0,
                lanhDaoDonVi: diemPheDuyet,
                diemDanhGia: diemDanhGia,
                trangThai: 0,
                idDonViPhuTrach: 0,
                tenDonVi: "",
                idNhanVien: 0
            }];
            var request = {
                isDuyet: isPheDuyet,
                lyDo: lyDo,
                danhSachDuyet: info
            };
            var id = await pheDuyetKPICaNhan(request);
            if (id > 0) {
                toast.success(isPheDuyet ? "Phê duyệt KPI thành công! Chuyển qua phê duyệt KPI của nhân viên khác" : "Trả lại KPI thành công! Chuyển qua phê duyệt KPI của nhân viên khác");
                setIdKPI(id);
                navigate(Links.KPI.ChiTietKPI + "?id=" + id);
            } else {
                toast.success(isPheDuyet ? "Phê duyệt KPI thành công! Đã hết KPI cần duyệt" : "Trả lại KPI thành công! Đã hết KPI cần duyệt");
                navigate(Links.KPI.DuyetKPI + "?thangNam=" + thangNam);
            }
        } catch (e: any) {
            toast.error(isPheDuyet ? "Phê duyệt KPI không thành công" : "Từ chối KPI không thành công");
        }

        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const eventLDPhongPheDuyetKPI = async () => {
        if (isLoading) return;
        form.validateFields().then(async () => {
            dispatch(showLoadingScreen())
            setIsLoading(true);

            try {
                var request = {
                    id: idKPI,
                    lyDo: lyDo,
                    nhomKPI: nhomKPI
                };

                const id = await lanhDaoPhongPheDuyetKPI(request);

                if (id > 0) {
                    toast.success("Phê duyệt KPI thành công! Chuyển qua phê duyệt KPI của nhân viên khác");
                    setIdKPI(id);
                    navigate(Links.KPI.ChiTietKPI + "?id=" + id);
                } else {
                    toast.success("Phê duyệt KPI thành công! Đã hết KPI cần duyệt");
                    navigate(Links.KPI.DuyetKPI + "?thangNam=" + thangNam);
                }
            } catch (error: any) {
                toast.error(error);
            }

            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
        });
    }

    const eventThuHoiKPI = async () => {
        if (isLoading) return;
        dispatch(showLoadingScreen())
        setIsLoading(true);

        try {
            await thuHoiKPICaNhan(idKPI);
            toast.success("Thu hồi KPI thành công");
            setIsReloadPage(true);
        } catch (e: any) {
            toast.error("Thu hồi KPI không thành công");
        }

        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const tuDanhGia = nhomKPI.reduce((x: any, y: any) => {
        return x + y.tuDanhGia;
    }, 0);

    const lanhDaoPhongDanhGia = nhomKPI.reduce((x: any, y: any) => {
        return idKPI > 0 ? (x + y.lanhDaoPhong) : 0;
    }, 0);

    const lanhDaoPhuTrachDanhGia = nhomKPI.reduce((x: any, y: any) => {
        return idKPI > 0 ? (x + y.lanhDaoPhuTrach) : 0;
    }, 0);

    // KPI có công việc được giao trong tháng thì không cho xóa
    const coCongViecDuocGiao = nhomKPI.some((nhom: NhomKPICaNhan) =>
        (nhom.chiTiet ?? []).some((ct: ChiTietKPICaNhan) => (ct.idNVGiao ?? 0) > 0 && (ct.idCha ?? 0) == 0));

    const onChange: DatePickerProps['onChange'] = async (date) => {
        if (date != null) {
            form.setFieldsValue({
                thangNam: date
            });
            setNgayThang(date);

            // cập nhật ngày của KPI nội quy, quy chế
            var thoiGianGiao = date.startOf('month').toDate();
            var thoiGianHoanThanh = date.endOf('month').toDate();

            const hanChot = await getHanChot(date);
            const isTre = hanChot ? dayjs().isAfter(hanChot) : false;
            
            var dsCongViec = await layCongViecChuaHoanThanh(date.format(monthFormat));
             setNhomKPI(nhomKPI =>
                nhomKPI.map((x: NhomKPICaNhan) => {
                    if (x.id === idNhomKPI.noiQuy) {
                        const defaultItem = x.chiTiet?.find(item => item.macDinh);
                        const wasTre = defaultItem ? defaultItem.tienDo === tienDoKPI.tre : false;
                        let newTuDanhGia = x.tuDanhGia;
                        if (wasTre && !isTre) {
                            newTuDanhGia = x.tuDanhGia + 4;
                        } else if (!wasTre && isTre) {
                            newTuDanhGia = x.tuDanhGia - 4;
                        }

                        return {
                            ...x,
                            tuDanhGia: newTuDanhGia,
                            chiTiet: x.chiTiet.map((item: ChiTietKPICaNhan) => {
                                if (item.macDinh) {
                                    return {
                                        ...item,
                                        thoiGianGiao: thoiGianGiao,
                                        thoiGianYeuCauHoanThanh: thoiGianHoanThanh,
                                        tienDo: isTre ? tienDoKPI.tre : tienDoKPI.dung,
                                        diemCaNhan: isTre ? -4 : null,
                                    };
                                }
                                return {
                                    ...item,
                                    thoiGianGiao: thoiGianGiao,
                                    thoiGianYeuCauHoanThanh: thoiGianHoanThanh,
                                };
                            }),
                        };
                    }
                    if (x.id === idNhomKPI.chuyenMon) {
                        // Xóa các công việc chưa hoàn thành của tháng cũ (idCha > 0),
                        // giữ lại các dòng do cá nhân tự thêm
                        const chiTietGiuLai = (x.chiTiet || []).filter(
                            (item: ChiTietKPICaNhan) => !(item.idCha && item.idCha > 0)
                        );
                        // Thêm mới danh sách công việc chưa hoàn thành theo tháng vừa chọn
                        const chiTietCongViec: Array<ChiTietKPICaNhan> = ((dsCongViec || []) as Array<any>).map((cv: any, idx: number) => ({
                            key: chiTietGiuLai.length + idx,
                            id: 0,
                            idCha: cv.id,
                            idChaKpi: cv.idKPI,
                            idNVGiao: cv.idNVGiao,
                            idKPI: 0,
                            idNhomKPI: idNhomKPI.chuyenMon,
                            tenCongViec: cv.tenCongViec,
                            thoiGianGiao: cv.thoiGianGiao,
                            thoiGianYeuCauHoanThanh: thoiGianHoanThanh,
                            chatLuong: cv.chatLuong ?? null,
                            tienDo: cv.tienDo ?? null,
                            ghiChu: cv.ghiChu ?? "",
                            diemCaNhan: cv.tienDo == tienDoKPI.tre ? -4 : null,
                            diemLanhDaoPhong: null,
                            diemLanhDaoPhuTrach: null,
                            isTieuDe: cv.isTieuDe ?? 0,
                            thuTu: idx + 1,
                            thuTuStr: String(idx + 1)
                        }));
                        // Đánh lại số thứ tự cho toàn bộ danh sách sau khi gộp
                        const chiTietMoi = [...chiTietGiuLai, ...chiTietCongViec];
                        let stt = 0;
                        let roman = 0;

                        chiTietMoi.forEach((item) => {
                            if (item.isTieuDe === 1) {
                                item.thuTuStr = convertToRoman(++roman);
                                stt = 0;
                            } else {
                                item.thuTuStr = String(++stt);
                            }
                        });
                        // Tính lại tuDanhGia: diemChuan trừ tổng điểm âm từ các công việc chưa hoàn thành
                        const tongDiemTru = chiTietMoi.reduce((sum: number, item: ChiTietKPICaNhan) => {
                            return sum + (item.diemCaNhan != null && item.diemCaNhan < 0 ? item.diemCaNhan : 0);
                        }, 0);

                        return {
                            ...x,
                            chiTiet: chiTietMoi,
                            isValid: true,
                            tuDanhGia: x.diemChuan + tongDiemTru
                        };
                    }
                    return x;
                })
            );
        }
    }

    const eventSetXepLoai = (diemXepLoai: number) => {
        switch (diemXepLoai) {
            case diemXepLoaiKPI.aPlus:
                setXepLoai("A+");
                break;
            case diemXepLoaiKPI.a:
                setXepLoai("A");
                break;
            case diemXepLoaiKPI.b:
                setXepLoai("B");
                break;
            case diemXepLoaiKPI.c:
                setXepLoai("C");
                break;
            default:
                setXepLoai("Chưa xếp loại");
                break;
        }
    }

    useEffect(() => {
        if ((trangThai >= trangThaiKPI.khoiTao || trangThai <= trangThaiKPI.lanhDaoPhongTuChoi)
            && idNhanVien != user.idNhanVien) {
            setIsDisable(true);
        } else if (trangThai >= trangThaiKPI.trinhLanhDaoPhong) {
            if (isLDPhong) {
                if (trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi) {
                    setIsDisable(false);
                } else if (trangThai == trangThaiKPI.lanhDaoDonViTuChoi) {
                    if (hasLDPhuTrach) {
                        setIsDisable(true);
                    } else {
                        setIsDisable(false);
                    }
                } else setIsDisable(true);
            } else setIsDisable(true);
        } else setIsDisable(false);
    }, [trangThai]);

    useEffect(() => {
        if (idBanDieuHanh > 0) {
            setDiemPheDuyet(getDiemXepLoaiByDiemDanhGia(tuDanhGia, diemChuyenMon));
            setDiemDanhGia(tuDanhGia);
        } else {
            if (hasLDPhuTrach) {
                setDiemPheDuyet(getDiemXepLoaiByDiemDanhGia(lanhDaoPhuTrachDanhGia, diemChuyenMon));
                setDiemDanhGia(lanhDaoPhuTrachDanhGia);
            } else {
                if (!isLDPhong) {
                    setDiemPheDuyet(getDiemXepLoaiByDiemDanhGia(lanhDaoPhongDanhGia, diemChuyenMon));
                    setDiemDanhGia(lanhDaoPhongDanhGia);
                } else {
                    setDiemPheDuyet(getDiemXepLoaiByDiemDanhGia(tuDanhGia, diemChuyenMon));
                    setDiemDanhGia(tuDanhGia);
                }
            }
        }
    }, [lanhDaoPhongDanhGia, lanhDaoPhuTrachDanhGia, tuDanhGia, idBanDieuHanh]);

    useEffect(() => {
        eventLoadKPI(idKPI);
    }, [idKPI]);

    useEffect(() => {
        if (isReloadPage) {
            if (idKPI > 0) {
                eventLoadKPI(idKPI);
            }
            setIsReloadPage(false);
        }
    }, [isReloadPage]);

    return (
        <section>
            <ContentHeader title="Chi tiết KPI Cá nhân" />
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
            {
                openModalPheDuyet &&
                <ModalTextForm
                    show={openModalPheDuyet}
                    title="Phê duyệt KPI"
                    handleClose={() => setOpenModalPheDuyet(false)}
                    handleSave={() => {
                        eventPheDuyetKPI(true);
                        setOpenModalPheDuyet(false);
                    }}
                >
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Phê duyệt </label> KPI này không? Hãy nhập nội dung (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            {
                openModalLDPhongPheDuyet &&
                <ModalTextForm
                    show={openModalLDPhongPheDuyet}
                    title="Phê duyệt KPI"
                    handleClose={() => setOpenModalLDPhongPheDuyet(false)}
                    handleSave={() => {
                        eventLDPhongPheDuyetKPI();
                        setOpenModalLDPhongPheDuyet(false);
                    }}
                >
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Phê duyệt </label> KPI này không? Hãy nhập nội dung (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            {
                openModalTuChoi &&
                <ModalTextForm
                    show={openModalTuChoi}
                    title="Từ chối KPI"
                    handleClose={() => setOpenModalTuChoi(false)}
                    handleSave={() => {
                        eventPheDuyetKPI(false);
                        setOpenModalTuChoi(false);
                    }}
                >
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Từ chối</label> KPI này không? Hãy nhập lý do (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            {
                openModalDuaYKien &&
                <ModalTextForm
                    show={openModalDuaYKien}
                    title="Đưa ý kiến KPI"
                    handleClose={() => setOpenModalDuaYKien(false)}
                    handleSave={() => {
                        eventDuaYKien();
                    }}
                >
                    <Row>
                        <Col span="24">
                                <TextArea
                                    placeholder="Nhập nội dung ý kiến"
                                    rows={6}
                                    value={lyDo}
                                    onChange={(e) => {
                                        setLyDo(e.target.value);
                                    }}
                                />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            {
                openModalTrinh &&
                <ModalTextForm
                    show={openModalTrinh}
                    title="Trình KPI"
                    handleClose={() => setOpenModalTrinh(false)}
                    handleSave={() => {
                        eventTrinhKPI(true);
                        setOpenModalTrinh(false);
                    }}
                >
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Trình </label> KPI này không? Hãy nhập nội dung (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            {
                openModalTraLai &&
                <ModalTextForm
                    show={openModalTraLai}
                    title="Trả lại KPI"
                    handleClose={() => setOpenModalTraLai(false)}
                    handleSave={() => {
                        eventTrinhKPI(false);
                        setOpenModalTraLai(false);
                    }}
                >
                    <Row>
                        <Col span="24">
                            Bạn có muốn <label>Trả lại</label> KPI này không? Hãy nhập lý do (nếu có):
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <TextArea
                                rows={2}
                                value={lyDo}
                                onChange={(e) => {
                                    setLyDo(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalTextForm>
            }
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
            >
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Tabs
                                tabBarExtraContent={
                                    <Space style={{ position: "fixed", zIndex: 1, right: "25px", top: "120px" }}>
                                        {
                                            // Button phê duyệt & từ chối KPI dành cho LĐ đơn vị
                                            trangThai == trangThaiKPI.trinhLanhDaoDonVi
                                            && menu[Links.KPI.LanhDaoDonViDuyet]
                                            && idKPI > 0 &&
                                            <>
                                                <Button
                                                    loading={isLoading}
                                                    type="primary"
                                                    icon={<CheckOutlined rev="" />}
                                                    onClick={() => {
                                                        setLyDo("");
                                                        setOpenModalPheDuyet(true);
                                                    }}
                                                >
                                                    Phê duyệt
                                                </Button>
                                                <Button
                                                    loading={isLoading}
                                                    type="primary"
                                                    className="hrm-btn-delete"
                                                    icon={<CloseOutlined rev="" />}
                                                    onClick={() => {
                                                        setLyDo("");
                                                        setOpenModalTuChoi(true);
                                                    }}
                                                >
                                                    Từ chối
                                                </Button>
                                            </>
                                        }
                                        {
                                            // Button trình KPI của LĐ phụ trách
                                            ((trangThai == trangThaiKPI.trinhLanhDaoPhuTrach || trangThai == trangThaiKPI.lanhDaoDonViTuChoi) && menu[Links.KPI.LanhDaoPhuTrachDuyet]) &&
                                            // bổ sung check user.idNhanVien = kpi.idLanhDaoPhuTrach
                                            idLanhDaoPhuTrach == user.idNhanVien &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => {
                                                    setIsTrinh(true);
                                                }}
                                            >
                                                Trình
                                            </Button>
                                        }
                                        {
                                            // Button trình Đưa ý kiến của LĐ phụ trách 1
                                            hasQuyenYKien &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                onClick={() => {
                                                    setOpenModalDuaYKien(true);
                                                }}
                                            >
                                                Đưa ý kiến
                                            </Button>
                                        }
                                        {
                                            // Button lưu & trình KPI của NV & của Ban điều hành không phải giám đốc
                                            ((((trangThai <= trangThaiKPI.lanhDaoPhongTuChoi && !isDisable && idNhanVien == user.idNhanVien)
                                                || (user.isLanhDaoPhong && idNhanVien == user.idNhanVien)) && !user.isLanhDaoPhong) ||
                                                (trangThai <= trangThaiKPI.khoiTao && !isDisable && idNhanVien == user.idNhanVien && user.maChucVu != maChucVu.giamDoc && idBanDieuHanh > 0))
                                            &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => {
                                                    setIsTrinh(true);
                                                }}
                                            >
                                                Lưu & Trình
                                            </Button>
                                        }
                                        {
                                            // Button phê duyệt của LĐ phòng
                                            ((trangThai == trangThaiKPI.trinhLanhDaoPhong || trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)
                                                || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && !hasLDPhuTrach) && menu[Links.KPI.LanhDaoPhongDuyet])
                                            && user.isLanhDaoPhong && idNhanVien != user.idNhanVien &&
                                            // bổ sung check user.idDonVi = kpi.idDonVi
                                            idDonVi == user.idDonVi &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                onClick={() => {
                                                    setLyDo("");
                                                    setOpenModalLDPhongPheDuyet(true);
                                                }}
                                            >
                                                Phê duyệt
                                            </Button>
                                        }
                                        {
                                            // Button trả lại KPI
                                            ((trangThai == trangThaiKPI.trinhLanhDaoPhong && menu[Links.KPI.LanhDaoPhongDuyet] && idDonVi == user.idDonVi)
                                                || (trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi && menu[Links.KPI.LanhDaoPhongDuyet] && !isLDPhong && idDonVi == user.idDonVi)
                                                || (trangThai == trangThaiKPI.trinhLanhDaoPhuTrach && menu[Links.KPI.LanhDaoPhuTrachDuyet] && idLanhDaoPhuTrach == user.idNhanVien)
                                                || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && menu[Links.KPI.LanhDaoPhuTrachDuyet] && idLanhDaoPhuTrach == user.idNhanVien)
                                                || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && menu[Links.KPI.LanhDaoPhongDuyet] && !hasLDPhuTrach && !isLDPhong && idDonVi == user.idDonVi))
                                            && idKPI > 0 && user.idNhanVien != idNhanVien &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                className="hrm-btn-delete"
                                                icon={<CloseOutlined rev="" />}
                                                onClick={() => {
                                                    setLyDo("");
                                                    setOpenModalTraLai(true);
                                                }}
                                            >
                                                Trả lại
                                            </Button>
                                        }
                                        {
                                            // Button lưu KPI
                                            (trangThai <= trangThaiKPI.lanhDaoPhongTuChoi
                                                || (trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi && isLDPhong))
                                            && !isDisable && idNhanVien == user.idNhanVien &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SaveOutlined rev="" />}
                                                htmlType="submit"
                                                onClick={() => {
                                                    setIsTrinh(false);
                                                }}
                                            >
                                                Lưu
                                            </Button>
                                        }
                                        {
                                            // Button thu hồi KPI
                                            trangThai == trangThaiKPI.trinhLanhDaoPhong
                                            && idNhanVien == user.idNhanVien && idKPI > 0 &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                className="hrm-btn-warning"
                                                icon={<UndoOutlined rev="" />}
                                                onClick={() => {
                                                    setConfirmModal({
                                                        isShowModal: true,
                                                        title: "Thu hồi KPI",
                                                        content:
                                                            <>Bạn có muốn <label>Thu hồi</label> KPI này không?</>,
                                                        onSubmit: eventThuHoiKPI
                                                    });
                                                }}
                                            >
                                                Thu hồi
                                            </Button>
                                        }
                                        {
                                            // Button xóa KPI
                                            trangThai <= trangThaiKPI.lanhDaoPhongTuChoi
                                            && !isDisable && idKPI > 0 && idNhanVien == user.idNhanVien
                                            && !coCongViecDuocGiao &&
                                            <Button
                                                loading={isLoading}
                                                className="hrm-btn-delete"
                                                icon={<DeleteOutlined rev="" />}
                                                onClick={() => {
                                                    setConfirmModal({
                                                        isShowModal: true,
                                                        title: "Xóa KPI",
                                                        content:
                                                            <>Bạn có muốn <label>Xóa</label> KPI này không?</>,
                                                        onSubmit: eventDeleteKPI
                                                    });
                                                }}
                                            >
                                                Xóa
                                            </Button>
                                        }
                                    </Space>
                                }
                                defaultActiveKey="1"
                                onChange={(key) => {
                                    if (key != "1") {
                                        setShowDetail(false);
                                    } else setShowDetail(true);
                                }}
                                items={[
                                    {
                                        key: "1",
                                        label: "KPI tháng",
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body" style={{ maxHeight: "100px" }}>
                                                    <Row gutter={48}>
                                                        <Col span="6">
                                                            <Form.Item
                                                                label="Họ và tên"
                                                            >
                                                                {tenNhanVien}
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="6">
                                                            {
                                                                <Form.Item<FieldKPICaNhan>
                                                                    name="thangNam"
                                                                    label="Tháng đánh giá"
                                                                    rules={[
                                                                        {
                                                                            required: true
                                                                        }
                                                                    ]}
                                                                >
                                                                    <DatePicker
                                                                        changeOnBlur={true}
                                                                        style={{ width: "100%" }}
                                                                        placeholder="Tháng đánh giá"
                                                                        allowClear={false}
                                                                        picker="month"
                                                                        format={thangNamFormat}
                                                                        disabled={isDisable || idKPI > 0}
                                                                        onChange={onChange}
                                                                    />
                                                                </Form.Item>
                                                            }
                                                        </Col>
                                                        <Col span="6">
                                                            <Form.Item
                                                                label="Phòng ban"
                                                            >
                                                                {tenDonVi}
                                                            </Form.Item>
                                                        </Col>
                                                        {
                                                            trangThai >= 0 &&
                                                            <Col span="6">
                                                                <Form.Item label="Trạng thái">
                                                                    <TrangThaiTag value={trangThai} />
                                                                </Form.Item>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </Col>
                                            </Row>
                                    },
                                    ...(idKPI > 0 ? [
                                        {
                                            key: '2',
                                            label: "Lịch sử thao tác",
                                            children: <LogNguoiDungTable data={logs} />
                                        }, {
                                            key: '3',
                                            label: "Lỗi vi phạm",
                                            children: <ThongKeLoiViPham idKPI={idKPI} trangThai={trangThai} thangNam={thangNam} />
                                        },
                                        {
                                            key: '4',
                                            label: "Hướng dẫn đánh giá",
                                            children: <HuongDanDanhGiaKPI idBanDieuHanh={idBanDieuHanh} />
                                        },
                                        {
                                            key: '5',
                                            label: "Thống kê",
                                            children: <ThongKeKPICaNhan
                                                idKPI={idKPI}
                                                trangThai={trangThai}
                                                thangNam={thangNam}
                                                user={user}
                                                setIsReloadPage={setIsReloadPage}
                                            />
                                        }
                                    ] : [
                                        {
                                            key: '4',
                                            label: "Hướng dẫn đánh giá",
                                            children: <HuongDanDanhGiaKPI idBanDieuHanh={idBanDieuHanh} />
                                        }])
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
                {
                    showDetail &&
                    <Row gutter={12}>
                        {!!yKien && trangThai == trangThaiKPI.trinhLanhDaoPhuTrach && < Col span="24">
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                        background: "linear-gradient(135deg, #fff7e6 0%, #fffbf0 100%)",
                                        border: "1px solid #ffd591",
                                        borderLeft: "5px solid #fa8c16",
                                        borderRadius: "8px",
                                        padding: "14px 18px",
                                        marginBottom: "12px",
                                        boxShadow: "0 2px 8px rgba(250, 140, 22, 0.12)",
                                    }}
                                >
                                    <CommentOutlined style={{ color: '#3b82f6', fontSize: "22px", marginTop: "2px" }} />
                                    <div style={{ flex: 1 }}>
                                        <label>Ý kiến của PGĐ phụ trách lĩnh vực</label>
                                        <div style={{ color: "#613400", fontSize: "15px", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
                                            {yKien}
                                        </div>
                                    </div>
                                </div>
                            </Col>}
                        <Col span={idBanDieuHanh > 0 ? "8" : "5"}>
                            <div className="card-outline">
                                <div className="card card-primary" >
                                    <div className="card-body" style={{ maxHeight: "60px" }}>
                                        <Row>
                                            <Col span="24">    Tự đánh giá
                                                <label className="float-right">
                                                    {
                                                        tuDanhGia
                                                    }
                                                </label>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {idBanDieuHanh == 0 && <><Col span="5">
                            <div className="card-outline">
                                <div className="card card-primary">
                                    <div className="card-body" style={{ maxHeight: "60px" }}>
                                        <Row>
                                            <Col span="24">  Lãnh đạo phòng
                                                <label className="float-right">
                                                    {
                                                        trangThai > trangThaiKPI.trinhLanhDaoPhong
                                                            ? lanhDaoPhongDanhGia > 0
                                                                ? lanhDaoPhongDanhGia
                                                                : ""
                                                            : (((trangThai == trangThaiKPI.trinhLanhDaoPhong || trangThai == trangThaiKPI.lanhDaoPhuTrachTuChoi)
                                                                || (trangThai == trangThaiKPI.lanhDaoDonViTuChoi && !hasLDPhuTrach) && menu[Links.KPI.LanhDaoPhongDuyet])
                                                                && user.isLanhDaoPhong && idNhanVien != user.idNhanVien &&
                                                                idDonVi == user.idDonVi) ? `Đang đánh giá (${lanhDaoPhongDanhGia})` : "Chưa đánh giá"
                                                    }
                                                </label>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                            <Col span="5">
                                <div className="card-outline">
                                    <div className="card card-primary">
                                        <div className="card-body" style={{ maxHeight: "60px" }}>
                                            <Row>
                                                <Col span="24"> LĐ phụ trách phòng
                                                    <label className="float-right">
                                                        {
                                                            trangThai > trangThaiKPI.trinhLanhDaoPhuTrach
                                                                ? lanhDaoPhuTrachDanhGia > 0
                                                                    ? lanhDaoPhuTrachDanhGia
                                                                    : ""
                                                                : (((trangThai == trangThaiKPI.trinhLanhDaoPhuTrach || trangThai == trangThaiKPI.lanhDaoDonViTuChoi) && menu[Links.KPI.LanhDaoPhuTrachDuyet]) &&
                                                                    idLanhDaoPhuTrach == user.idNhanVien) ? `Đang đánh giá (${lanhDaoPhuTrachDanhGia})` : "Chưa đánh giá"
                                                        }
                                                    </label>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </>}
                        <Col span={idBanDieuHanh > 0 ? "8" : "5"}>
                            <div className="card-outline">
                                <div className="card card-primary">
                                    <div className="card-body" style={{ maxHeight: "60px" }}>
                                        <Row>
                                            <Col span="24"> Điểm đánh giá
                                                {
                                                    (trangThai == trangThaiKPI.trinhLanhDaoDonVi && menu[Links.KPI.LanhDaoDonViDuyet] && idKPI > 0)
                                                        ? <InputNumber
                                                            value={diemDanhGia}
                                                            onChange={(value: any) => {
                                                                setDiemPheDuyet(getDiemXepLoaiByDiemDanhGia(value));
                                                                setDiemDanhGia(value);
                                                            }}
                                                            className="hide-arrow float-right"
                                                        />
                                                        : <label className="float-right">
                                                            {
                                                                diemDanhGiaLabel != null ? diemDanhGiaLabel : "Chưa đánh giá"
                                                            }
                                                        </label>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={idBanDieuHanh > 0 ? "8" : "4"}>
                            <div className="card-outline">
                                <div className="card card-primary">
                                    <div className="card-body" style={{ maxHeight: "60px" }}>
                                        <Row>
                                            <Col span="24">  Xếp loại
                                                {
                                                    (trangThai == trangThaiKPI.trinhLanhDaoDonVi && menu[Links.KPI.LanhDaoDonViDuyet] && idKPI > 0)
                                                        ? <DiemPheDuyetSelectBox
                                                            value={diemPheDuyet}
                                                            diemChuyenMon={diemChuyenMon}
                                                            onChange={(e: any) => {
                                                                setDiemPheDuyet(e.target.value);
                                                                setDiemDanhGia(getDiemDanhGiaByDiemXepLoai(e.target.value));
                                                            }} />
                                                        : <label className="float-right">
                                                            {
                                                                xepLoai ? xepLoai : "Chưa xếp loại"
                                                            }
                                                        </label>
                                                }
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                }
                {
                    showDetail &&
                    nhomKPI.map((x: NhomKPICaNhan, idx: number) =>
                        <Row key={x.id}>
                            <Col span="24">
                                <div className="card-outline">
                                    {
                                        isDisable
                                            ? <ViewChiTietKPITab
                                                idNhanVien={idNhanVien}
                                                tieuDe={x.ten + " (Điểm chuẩn: " + x.diemChuan + ")"}
                                                source={x}
                                                trangThai={trangThai}
                                                thoiGian={ngayThang}
                                                idDonVi={idDonVi}
                                                isLDPhong={isLDPhong}
                                                hasLDPhuTrach={hasLDPhuTrach}
                                                idLDPhuTrach={idLanhDaoPhuTrach}
                                                idBanDieuHanh={idBanDieuHanh}
                                                disabled={isDisable}
                                                valid={x.isValid}
                                                showError={isShowError}
                                                onChange={(data: NhomKPICaNhan, showErr: boolean) => {
                                                    nhomKPI[idx].chiTiet = data.chiTiet;
                                                    nhomKPI[idx].tuDanhGia = data.tuDanhGia || 0;
                                                    nhomKPI[idx].lanhDaoPhong = data.lanhDaoPhong;
                                                    nhomKPI[idx].lanhDaoPhuTrach = data.lanhDaoPhuTrach;
                                                    if (data.tuDanhGia > 0) {
                                                        if (data.chiTiet != null && data.chiTiet.length > 0) {
                                                            nhomKPI[idx].isValid = true;
                                                        } else nhomKPI[idx].isValid = false;
                                                    } else nhomKPI[idx].isValid = true;
                                                    setNhomKPI([...nhomKPI]);
                                                    setIsShowError(showErr);
                                                }}
                                            />
                                            : <EditChiTietKPITab
                                                idNhanVien={idNhanVien}
                                                tieuDe={x.ten + " (Điểm chuẩn: " + x.diemChuan + ")"}
                                                source={x}
                                                trangThai={trangThai}
                                                thoiGian={ngayThang}
                                                isLDPhong={isLDPhong}
                                                hasLDPhuTrach={hasLDPhuTrach}
                                                disabled={isDisable}
                                                valid={x.isValid}
                                                showError={isShowError}
                                                onChange={(data: NhomKPICaNhan, showErr: boolean) => {
                                                    let stt = 0;
                                                    let roman = 0;
                                                    data.chiTiet.forEach((item) => {
                                                        if (item.isTieuDe === 1) {
                                                            item.thuTuStr = convertToRoman(++roman);
                                                            stt = 0;
                                                        } else {
                                                            item.thuTuStr = ++stt;
                                                        }
                                                    });
                                                    nhomKPI[idx].chiTiet = data.chiTiet;
                                                    nhomKPI[idx].tuDanhGia = data.tuDanhGia || 0;
                                                    nhomKPI[idx].lanhDaoPhong = data.lanhDaoPhong;
                                                    nhomKPI[idx].lanhDaoPhuTrach = data.lanhDaoPhuTrach
                                                    nhomKPI[idx].idsTaiLieuXoa = data.idsTaiLieuXoa;
                                                    nhomKPI[idx].dsTaiLieu = data.dsTaiLieu;
                                                    if (data.tuDanhGia > 0) {
                                                        if (data.chiTiet != null && data.chiTiet.length > 0) {
                                                            nhomKPI[idx].isValid = true;
                                                        } else nhomKPI[idx].isValid = false;
                                                    } else nhomKPI[idx].isValid = true;
                                                    setNhomKPI([...nhomKPI]);
                                                    setIsShowError(showErr);
                                                }}
                                            />
                                    }
                                </div>
                            </Col>
                        </Row>
                    )
                }
            </Form>
        </section>
    );
};

export default ChiTietKPI;
